import { Download } from "lucide-react";

const BLUEPRINT_URL =
  "https://customer-assets.emergentagent.com/job_kisubika-ar-preview/artifacts/iqdfz38c_photo_2026-05-09_00-45-25.jpg";

const Spec = ({ label, value, sub }) => (
  <div className="border-l border-white/30 pl-4">
    <div className="kb-mono-label text-white/60">{label}</div>
    <div className="font-serif text-2xl sm:text-3xl text-white mt-1">{value}</div>
    {sub && <div className="kb-mono-label text-white/50 mt-1">{sub}</div>}
  </div>
);

export const SpecSheet = ({ color }) => {
  return (
    <section
      data-testid="spec-sheet"
      className="mt-16 sm:mt-24 bg-[var(--kb-blue)] text-white relative overflow-hidden"
    >
      <div className="px-6 sm:px-10 py-12 sm:py-16 grid lg:grid-cols-12 gap-10 items-start">
        <div className="lg:col-span-4">
          <div className="kb-mono-label text-white/70">04 · The Blueprint</div>
          <h2 className="font-serif text-4xl sm:text-5xl leading-[0.95] tracking-tight mt-3">
            Architecture<br />
            <span className="italic text-white/80">in canvas.</span>
          </h2>
          <p className="mt-5 text-[15px] leading-relaxed text-white/75 font-light max-w-sm">
            One silhouette. Twenty pigments. Cut and stitched in our London
            atelier from heavy-weight cotton canvas, hand-screened with the
            KISUBIKA wordmark.
          </p>

          <div className="mt-8 grid grid-cols-2 gap-x-3 gap-y-6">
            <Spec label="WIDTH" value="430" sub="MILLIMETRES" />
            <Spec label="HEIGHT" value="360" sub="MILLIMETRES" />
            <Spec label="DEPTH" value="140" sub="MILLIMETRES" />
            <Spec label="HANDLE" value="240" sub="DROP · MM" />
            <Spec label="MATERIAL" value="Canvas" sub="HEAVY-WEIGHT COTTON" />
            <Spec
              label="THIS COLOUR"
              value={color.name.split(" ")[0]}
              sub={color.name}
            />
          </div>

          <a
            data-testid="spec-download"
            href={BLUEPRINT_URL}
            download="kisubika-tote-blueprint.jpg"
            target="_blank"
            rel="noopener noreferrer"
            className="kb-btn-ghost mt-8 !text-white !border-white hover:!bg-white hover:!text-[var(--kb-blue)]"
          >
            <Download size={14} /> Download blueprint
          </a>
        </div>

        <div className="lg:col-span-8">
          <div className="relative aspect-square w-full">
            <div className="absolute -top-3 left-3 kb-mono-label text-white/50 z-10">
              KSB-001 · TECHNICAL DRAWING · 1:1
            </div>
            <div className="absolute -top-3 right-3 kb-mono-label text-white/50 z-10">
              REV.A · LDN · 2026
            </div>
            <img
              src={BLUEPRINT_URL}
              alt="KISUBIKA tote blueprint with 430mm width, 360mm height, 140mm depth and 240mm handle drop"
              className="w-full h-full object-cover border border-white/20"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
